import { postRequest } from '@/core';
import { savedLoadPlanningSearches } from '@/requests';

export default async function newSavedLoadPlanningSearchesRequest(savedSearch) {
	let url = savedLoadPlanningSearches.getPath();
	let response = await postRequest(url, {},  savedSearch);
	return response;
}
